import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { useTheme } from '@/context/ThemeContext'
import { ROLE_COLORS, ROLE_TEXT } from '../types'

type Props = {
  current: 'owner' | 'admin' | 'member'
  membershipId: string
  myRole: string
  isMe: boolean
  onChanged: (membershipId: string, newRole: 'admin' | 'member') => void
}

const RoleDropdown: React.FC<Props> = ({ current, membershipId, myRole, isMe, onChanged }) => {
  const { currentTheme: t } = useTheme()
  const [open, setOpen] = useState(false)
  const canEdit = !isMe && current !== 'owner' && (myRole === 'owner' || myRole === 'admin')

  if (!canEdit) {
    return (
      <span
        className="px-2.5 py-[3px] rounded-full text-[11.5px] font-semibold"
        style={{ backgroundColor: ROLE_COLORS[current], color: ROLE_TEXT[current] }}
      >
        {current.charAt(0).toUpperCase() + current.slice(1)}
      </span>
    )
  }

  return (
    <div className="relative">
      <button
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-[5px] px-2.5 py-[3px] rounded-full text-[11.5px] font-semibold transition-opacity hover:opacity-80"
        style={{ backgroundColor: ROLE_COLORS[current], color: ROLE_TEXT[current] }}
      >
        {current.charAt(0).toUpperCase() + current.slice(1)}
        <ChevronDown size={10} />
      </button>
      {open && (
        <div
          className="absolute right-0 top-7 z-10 w-28 rounded-[10px] overflow-hidden shadow-lg py-1"
          style={{ backgroundColor: t.secondary, border: `1px solid ${t.border}` }}
        >
          {(['admin', 'member'] as const).filter((r) => r !== current).map((r) => (
            <button
              key={r}
              onClick={() => { setOpen(false); onChanged(membershipId, r) }}
              className="w-full text-left px-3.5 py-2 text-[12.5px] font-medium transition-colors"
              style={{ color: ROLE_TEXT[r] }}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = t.hoverBackground }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
            >
              {r.charAt(0).toUpperCase() + r.slice(1)}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default React.memo(RoleDropdown)
